import classNames from 'classnames';
import React from 'react';
import SVGIcon from '../../components/SVGIcon';
import tocIcon from '../../icons/non-prefilled/16x16/tableOfContents.svg';
import ConnectedTableOfContents from './ConnectedTableOfContents';
import PostActionButton from './PostActionButton';
import PostTOCPopOver from './PostTOCPopOver';
import { usePostTOC } from '../PostTOCContext';

interface BaseTOCButtonProps {
  active?: boolean;
  disabled?: boolean;
  onClick?: React.MouseEventHandler;
}

export const BaseTOCButton = ({
  active,
  disabled,
  onClick,
}: BaseTOCButtonProps) => {
  const ariaLabel = active
    ? 'Hide table of contents'
    : 'Show table of contents';

  return (
    <div
      className={classNames('post-toc-button', {
        'post-toc-button-active': active,
      })}
    >
      <PostActionButton
        disabled={disabled}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        <SVGIcon size="large">{tocIcon}</SVGIcon>
      </PostActionButton>
    </div>
  );
};

interface PostTOCButtonProps {
  postId: string;
}

const PostTOCButton = ({ postId }: PostTOCButtonProps) => {
  const { isTOCOpen, toggleTOC } = usePostTOC();
  return (
    <ConnectedTableOfContents postId={postId}>
      {(tocProps) => {
        const hasHeaders = tocProps.headers.length > 0;
        const button = (
          <BaseTOCButton
            active={isTOCOpen}
            disabled={!hasHeaders}
            onClick={() => toggleTOC()}
          />
        );

        return (
          <>
            <div className="post-toc-button-sticky">
              {isTOCOpen ? (
                button
              ) : (
                <PostTOCPopOver tocProps={tocProps}>{button}</PostTOCPopOver>
              )}
            </div>
            <div className="post-toc-button-pop-over">
              <PostTOCPopOver tocProps={tocProps}>
                <BaseTOCButton disabled={!hasHeaders} />
              </PostTOCPopOver>
            </div>
          </>
        );
      }}
    </ConnectedTableOfContents>
  );
};

export default PostTOCButton;
